import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.5 2.25C3.25736 2.25 2.25 3.25736 2.25 4.5V5.37868C2.25 5.97542 2.48705 6.54771 2.90901 6.96967L6.53033 10.591C6.67098 10.7316 6.75 10.9224 6.75 11.1213V15.0427C6.75 16.0901 7.79606 16.815 8.77668 16.4472L10.2767 15.8847C10.8621 15.6652 11.25 15.1055 11.25 14.4802V11.1213C11.25 10.9224 11.329 10.7316 11.4697 10.591L15.091 6.96967C15.5129 6.54771 15.75 5.97542 15.75 5.37868V4.5C15.75 3.25736 14.7426 2.25 13.5 2.25H4.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }